import { Component, Input } from '@angular/core';
import { NbComponentStatus } from '@nebular/theme';

@Component({
  standalone: false,
  selector: 'wr-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
})
export class ConfirmDialogComponent {

  @Input() message?: string;
  @Input() header?: string;
  @Input() status: NbComponentStatus = 'warning';
  @Input() submitText?: string;
  @Input() cancelText?: string;
}
